module.exports = __webpack_public_path__ + "static/bilo-bilo-fe36282ebe27712b1f3c70b49e03bbbb.jpg";